import { motion } from "framer-motion";
import { PROCESS_PHASES } from "@/lib/content";
import * as Icons from "lucide-react";

export default function Process() {
  return (
    <section id="process" data-testid="process-section" className="relative py-24">
      <div className="container-edx">
        <div className="max-w-3xl">
          <div className="section-index">EDX.07</div>
          <h2 className="display mt-4 text-4xl sm:text-5xl md:text-6xl text-white">
            8 phases. <span className="gradient-text">Zero surprises.</span>
          </h2>
        </div>
        <div className="mt-14 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5">
          {PROCESS_PHASES.map((p, i) => {
            const Icon = (Icons as any)[p.icon] || Icons.Sparkles;
            return (
              <motion.div
                key={p.n} data-testid={`phase-${p.n}`}
                initial={{ opacity: 0, y: 20 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true }}
                transition={{ duration: 0.4, delay: i * 0.06 }}
                className="glass glass-edge p-6 tilt relative"
              >
                <div className="absolute top-4 right-4 text-[10px] font-mono text-edx-muted">0{p.n}</div>
                <div className="h-11 w-11 rounded-xl bg-gradient-to-br from-edx-cyan via-edx-purple to-edx-pink p-[2px]">
                  <div className="h-full w-full rounded-[10px] bg-edx-space flex items-center justify-center text-white">
                    <Icon size={18} />
                  </div>
                </div>
                <h3 className="display font-bold text-base text-white mt-4">{p.title}</h3>
                <p className="text-xs text-edx-muted mt-2 leading-relaxed">{p.desc}</p>
              </motion.div>
            );
          })}
        </div>
      </div>
    </section>
  );
}
